module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAGElEQVQImWM0NDT8z4AEmJA5RAgwMDAAAGb6AZqZ09kvAAAAAElFTkSuQmCC"